/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import {
  csuCountry,
  jobCategory,
  occupationOptions,
  optionStringValues,
} from 'components/helper/helper';
import { canadaProvince, usaState } from 'components/helper/stateAndCounty';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import collegeServices from 'services/collegeServices';
import TextIconInput from 'components/input/TextIconInput';
import SearchIcon from '@mui/icons-material/Search';
import LoadingContent from 'components/LoadingContent';
import { debounce, defer } from 'lodash';
import Card from '@mui/material/Card';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Grid from '@mui/joy/Grid';
import ConditionalGrid from 'components/helper/ConditionalGrid';
import { states_usa } from 'components/helper/state_usa';

export const CollegeSchoolType = ['2-year or community college', '4-year college or university'];

export const getStateName = (stateCode: string) => {
  for (let i = 0; i < states_usa.length; i++) {
    if (states_usa[i].value === stateCode) return states_usa[i].name;
  }
  return stateCode;
};

interface Props {
  formik: any;
  parentNumber?: number;
  check?: any;
  isMobile?: boolean;
  disabled?: boolean;
}

const Employment = (props: Props) => {
  // const { isMobile = false } = props;
  const [searchInput, setSearchInput] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [openMenu, setOpenMenu] = React.useState(false);
  const [selectedEducation, setSelectedEducation] = React.useState<any>();
  let searchCtrl = new AbortController();

  const { formik } = props;
  const [collegeData, setCollegeData] = React.useState<any>();
  const yearRetiredOptions: any = useMemo(
    () => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),
    []
  );
  const yearAtHomeOptions: any = useMemo(
    () => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),
    []
  );
  const yearNotEmployedOptions: any = useMemo(
    () => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),
    []
  );
  const yearAtJobOptions: any = useMemo(
    () => optionStringValues(Array.from({ length: 70 }, (_, i) => i + 1)),
    []
  );
  const employmentStatusOptions = ['Employed', 'Unemployed', 'Retired', 'Self-Employed'];
  const jobStatusOptions = ['Employed', 'Stay-at-home parent/homemaker', 'Not-employed', 'Retired'];
  const employedOrRetireollegeOptions = [
    'Never employed at a college/university',
    'Currently employed at a college/university',
    'Retired from a college/university',
  ];
  const checkCountry = () => {
    if (
      formik.values.college_or_university.country !== 'Canada' &&
      formik.values.college_or_university.country !== 'United States of America'
    ) {
      formik.setFieldValue('college_or_university.state', null);
      formik.setFieldValue('college_or_university.province', null);
      if (!formik.values.college_or_university.state_or_province) {
        formik.setFieldValue('college_or_university.state_or_province', '');
      }
    }
  };

  const handleGetCollege = async (keyword: string) => {
    setIsLoading(true);
    searchCtrl.abort();
    searchCtrl = new AbortController();
    setIsLoading(true);
    let res: any = await collegeServices.findCollege(keyword, searchCtrl);
    const data = res.map((item: any) => ({
      ...item,
      id: item.id,
      label: item.name,
      value: item.name,
    }));

    setCollegeData(data);
    setIsLoading(false);
    setOpenMenu(true);
  };

  const handleSearchCollege = debounce((keyword: string) => {
    defer(() => {
      handleGetCollege(keyword);
    });
  }, 300);

  React.useEffect(() => {
    const college = props.formik.values.college_or_university;
    if (college?.name === 'null') {
      college.name = '';
    }
    if (college?.name) {
      setSelectedEducation(college);
    }
  }, []);

  const handleFormChange = (e: any) => {
    checkCountry();
    formik.handleChange(e);
  };

  const handleChangeItem = (college: any) => {
    setSelectedEducation(college);
    formik.setFieldValue('college_or_university', college);
    setOpenMenu(false);
    setSearchInput('');
  };

  return (
    <>
      <Grid xs={12}>
        <div className="text-dart fs-5">Employment</div>
      </Grid>

      <Grid xs={12}>
        <GroupRadioButton
          label="What is this parent's current job status?*"
          columns={2}
          logo="span-uc-logo"
          mdCol={6}
          options={jobStatusOptions}
          name="parent_current_job_status"
          values={props.formik.values.parent_current_job_status}
          onChange={props.formik.handleChange}
          isMissing={!props.formik.values.parent_current_job_status && props.check}
          disabled={props.disabled}
        />
      </Grid>

      <Grid xs={12} md={6}>
        <SelectInput
          logo="span-cm-logo"
          form={props.formik}
          name="employment_status"
          values={props.formik.values.employment_status}
          option={employmentStatusOptions}
          label="Employment status*"
          isSatTest={true}
          onChange={props.formik.handleChange}
          isMissing={!props.formik.values.employment_status && props.check}
          disabled={props.disabled}
        />
      </Grid>

      <ConditionalGrid
        xs={12}
        md={6}
        hidden={props.formik.values.parent_current_job_status !== 'Employed'}
      >
        <TextInput
          label="Current Employer"
          name="current_employer"
          countText={40}
          values={props.formik.values.current_employer}
          onChange={props.formik.handleChange}
          disabled={props.disabled}
        />
      </ConditionalGrid>

      {props.formik.values.parent_current_job_status === 'Stay-at-home parent/homemaker' && (
        <Grid xs={12} md={6}>
          <SelectInput
            option={yearAtHomeOptions}
            label="How many years has this parent been a stay-at-home parent?"
            logo="span-uc-logo"
            name="number_of_year_at_home"
            values={props.formik.values.number_of_year_at_home}
            onChange={props.formik.handleChange}
            disabled={props.disabled}
          />
        </Grid>
      )}

      {props.formik.values.parent_current_job_status === 'Not-employed' && (
        <Grid xs={12} md={6}>
          <SelectInput
            option={yearNotEmployedOptions}
            label="How many years has this parent not been employed?"
            logo="span-uc-logo"
            name="number_of_year_not_employed"
            values={props.formik.values.number_of_year_not_employed}
            onChange={props.formik.handleChange}
            isCMLogo
            disabled={props.disabled}
          />
        </Grid>
      )}

      {props.formik.values.parent_current_job_status === 'Retired' && (
        <Grid xs={12} md={6}>
          <SelectInput
            option={yearRetiredOptions}
            label="How many years has this parent been retired?"
            logo="span-uc-logo"
            isCMLogo
            name="number_of_year_retired"
            values={props.formik.values.number_of_year_retired}
            onChange={props.formik.handleChange}
            disabled={props.disabled}
          />
        </Grid>
      )}

      <Grid xs={12} className="flex-row">
        <div className="text-dart mt-3 d-flex align-items-center">
          Most recent/Former job held by this parent info:
          <span className="uc-logo ml-2"></span>
        </div>
      </Grid>

      <Grid xs={12} md={6}>
        <SelectInput
          className={`common-flag ${
            props.formik.values.parent_current_job_status === 'Employed' && 'end-flag'
          }`}
          form={props.formik}
          option={occupationOptions}
          label="Occupation (former occupation, if retired or deceased)"
          name="occupation"
          values={props.formik.values.occupation}
          onChange={props.formik.handleChange}
          disabled={props.disabled}
        />
      </Grid>

      <Grid xs={12} md={6}>
        <SelectInput
          // logo="span-uc-logo"
          label="Job Category*"
          isSatTest={true}
          name="job_category"
          values={props.formik.values.job_category}
          onChange={props.formik.handleChange}
          option={jobCategory}
          isMissing={!props.formik.values.job_category && props.check}
        />
      </Grid>

      <Grid xs={12} md={6}>
        <TextInput
          label="Job title*"
          countText={20}
          name="job_title"
          values={props.formik.values.job_title}
          onChange={props.formik.handleChange}
          isMissing={!props.formik.values.job_title && props.check}
          disabled={props.disabled}
        />
      </Grid>

      <Grid xs={12} md={6}>
        <SelectInput
          option={yearAtJobOptions}
          // logo="span-uc-logo"
          label="Number of years at job"
          isSatTest={true}
          name="number_of_year_at_job"
          values={props.formik.values.number_of_year_at_job}
          onChange={props.formik.handleChange}
          disabled={props.disabled}
        />
      </Grid>

      {props.formik.values.occupation === 'Other' && (
        <Grid xs={12}>
          <TextInput
            label="Other Occupation Details"
            name="other_occupation_detail"
            values={props.formik.values.other_occupation_detail}
            onChange={props.formik.handleChange}
            countText={50}
            disabled={props.disabled}
          />
        </Grid>
      )}

      {['Employed', 'Retired'].includes(props.formik.values.employment_status) && (
        <>
          <Grid xs={12}>
            <GroupRadioButton
              className="py-4"
              label="Is parent currently employed by or retired from a college or university?*"
              logo="span-cm-logo"
              verticalLayout={true}
              name="parent_currently_employed_or_retire_from_college"
              values={props.formik.values.parent_currently_employed_or_retire_from_college}
              onChange={props.formik.handleChange}
              mdCol={12}
              options={employedOrRetireollegeOptions}
              isMissing={
                !props.formik.values.parent_currently_employed_or_retire_from_college && props.check
              }
              disabled={props.disabled}
            />
          </Grid>

          {[
            'Currently employed at a college/university',
            'Retired from a college/university',
          ].includes(props.formik.values.parent_currently_employed_or_retire_from_college) && (
            <>
              <Grid xs={12} md={6}>
                <TextIconInput
                  label="College/University employer lookup*"
                  logo="span-cm-logo"
                  icon={<SearchIcon />}
                  onChange={(e: any) => {
                    setSearchInput(e.target.value);
                    handleSearchCollege(e.target.value);
                    formik.setFieldValue('college_or_university.name', e.target.value);
                  }}
                  values={searchInput}
                  isMissing={!formik.values?.college_or_university?.name && props.check}
                  disabled={props.disabled}
                />
              </Grid>

              {isLoading && <LoadingContent />}
              {collegeData !== undefined &&
                !collegeData?.length &&
                !isLoading &&
                !formik.values.college_or_university?.name && (
                  <Grid xs={12}>
                    <div className="text-center">Not found college</div>
                  </Grid>
                )}

              {openMenu && collegeData && (
                <>
                  <div className="lookup-search-result">
                    {(collegeData || []).map((college: any, index: React.Key | null | undefined) =>
                      college?.label ? (
                        <Card className="border rounded my-1 pt-2 pb-1" key={index}>
                          <div className="d-flex align-items-end position-relative cursor-pointer">
                            <div
                              className="mx-3 pb-1 text-overflow-ellipses"
                              onClick={() => {
                                handleChangeItem(college);
                              }}
                              title={college.label}
                            >
                              <span>{college.label}</span>
                              <span
                                className="mx-1 text-field-light sized70"
                                title={`(ceeb: ${college?.ceeb ?? ''}, city: ${
                                  college?.city ?? ''
                                }, state: ${getStateName(college?.state) ?? ''}, country: ${
                                  college?.country ?? ''
                                })`}
                              >
                                {`(ceeb: ${college?.ceeb ?? ''}, city: ${
                                  college?.city ?? ''
                                }, state: ${getStateName(college?.state) ?? ''}, country: ${
                                  college?.country ?? ''
                                })`}
                              </span>
                            </div>

                            <span className="position-absolute h-100 d-flex align-items-center end-0">
                              <AddIcon
                                fontSize="small"
                                className={`bg-app text-primary rounded-circle mx-3 ${
                                  props.disabled ? 'disabled-icon' : 'pointer'
                                }`}
                                onClick={
                                  props.disabled
                                    ? undefined
                                    : () => {
                                        handleChangeItem(college);
                                      }
                                }
                                style={{
                                  opacity: props.disabled ? 0.5 : 1,
                                  cursor: props.disabled ? 'not-allowed' : 'pointer',
                                }}
                              />
                            </span>
                          </div>
                        </Card>
                      ) : null
                    )}
                  </div>
                </>
              )}
              {selectedEducation?.id ? (
                <>
                  <Grid xs={12}>
                    <div className="my-2 text-field-light">Employer Graduation College</div>
                    <div className="d-flex align-items-end position-relative">
                      <div
                        className="mx-3 pb-2 fw-bold"
                        style={{
                          color: '#4d88f0',
                        }}
                      >
                        {selectedEducation?.name}
                      </div>
                      <div className="text-field-light sized70  pb-2">
                        {selectedEducation?.address_line_1}
                      </div>
                      <span className="position-absolute h-100 d-flex align-items-center end-0">
                        <RemoveIcon
                          fontSize="small"
                          className={`bg-light text-dart rounded-circle mx-4 ${
                            props.disabled ? 'disabled-icon' : 'pointer'
                          }`}
                          onClick={
                            props.disabled
                              ? undefined
                              : () => {
                                  setSelectedEducation(undefined);
                                  formik.setFieldValue('college_or_university', null);
                                }
                          }
                          style={{
                            opacity: props.disabled ? 0.5 : 1,
                            cursor: props.disabled ? 'not-allowed' : 'pointer',
                          }}
                        />
                      </span>
                    </div>
                  </Grid>
                </>
              ) : (collegeData !== undefined && !collegeData?.length) || selectedEducation?.name ? (
                <>
                  <Grid xs={12}>
                    <div className="my-2 text-field-light">Employer Graduation College</div>
                  </Grid>
                  <Grid xs={12}>
                    <Grid container spacing={3} className="bg-white rounded p-3">
                      <Grid xs={12} md={12}>
                        <TextInput
                          name={'college_or_university.name'}
                          values={formik.values?.college_or_university?.name}
                          onChange={handleFormChange}
                          label="Name of college/university*"
                          countText={60}
                          isMissing={!formik.values?.college_or_university?.name && props.check}
                          disabled={props.disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={12}>
                        <TextInput
                          name={'college_or_university.city'}
                          values={formik.values?.college_or_university?.city}
                          onChange={handleFormChange}
                          label="City"
                          countText={30}
                          disabled={props.disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={12}>
                        <SelectInput
                          name={'college_or_university.school_type'}
                          values={formik.values?.college_or_university?.school_type}
                          onChange={handleFormChange}
                          label="School Type *"
                          option={CollegeSchoolType}
                          isMissing={
                            !formik.values?.college_or_university?.school_type && props.check
                          }
                          disabled={props.disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={12}>
                        <AutocompleteInput
                          name={'college_or_university.country'}
                          form={formik}
                          values={formik.values?.college_or_university?.country}
                          label="Country/Region/Territory*"
                          option={csuCountry}
                          isMissing={!formik.values?.college_or_university?.country && props.check}
                          onChange={(e: any) => {
                            if (
                              formik.values?.college_or_university?.country !== 'Canada' &&
                              formik.values?.college_or_university?.country !==
                                'United States of America'
                            ) {
                              formik.setFieldValue('college_or_university.state', null);
                              formik.setFieldValue('college_or_university.province', null);
                              if (!formik.values?.college_or_university?.state_or_province) {
                                formik.setFieldValue('college_or_university.state_or_province', '');
                              }
                            }
                          }}
                        />
                      </Grid>

                      <ConditionalGrid
                        xs={12}
                        md={12}
                        hidden={
                          formik.values?.college_or_university?.country !==
                          'United States of America'
                        }
                      >
                        <AutocompleteInput
                          option={usaState}
                          form={formik}
                          label="State*"
                          name={'college_or_university.state'}
                          values={formik.values?.college_or_university?.state}
                          isMissing={!formik.values?.college_or_university?.state && props.check}
                          disabled={props.disabled}
                        />
                      </ConditionalGrid>

                      <ConditionalGrid
                        xs={12}
                        md={12}
                        hidden={formik.values?.college_or_university?.country !== 'Canada'}
                      >
                        <AutocompleteInput
                          form={formik}
                          option={canadaProvince}
                          label="Province*"
                          name={'college_or_university.province'}
                          values={formik.values?.college_or_university?.province}
                          isMissing={!formik.values?.college_or_university?.province && props.check}
                          disabled={props.disabled}
                        />
                      </ConditionalGrid>

                      <ConditionalGrid
                        xs={12}
                        md={12}
                        hidden={
                          formik.values?.college_or_university?.country === 'Canada' ||
                          formik.values?.college_or_university?.country ===
                            'United States of America'
                        }
                      >
                        <TextInput
                          name={'college_or_university.state_or_province'}
                          values={formik.values?.college_or_university?.state_or_province}
                          onChange={(e: any) => {
                            formik.setFieldValue('college_or_university.state', null);
                            formik.setFieldValue('college_or_university.province', null);
                            formik.setFieldValue(
                              'college_or_university.state_or_province',
                              e.target.value
                            );
                            handleFormChange(e);
                          }}
                          label="State or Province"
                          countText={30}
                          disabled={props.disabled}
                        />
                      </ConditionalGrid>

                      <Grid xs={12} md={12}>
                        <TextInput
                          name={'college_or_university.zip_code'}
                          values={formik.values?.college_or_university?.zip_code}
                          onChange={handleFormChange}
                          label="Zip Code*"
                          countText={10}
                          isMissing={!formik.values?.college_or_university?.zip_code && props.check}
                          disabled={props.disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={12}>
                        <TextInput
                          name={'college_or_university.ceeb'}
                          values={formik.values?.college_or_university?.ceeb}
                          onChange={handleFormChange}
                          label="CEEB Code"
                          countText={10}
                          disabled={props.disabled}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null}
            </>
          )}
        </>
      )}
      <style scoped>{`
.lookup-search-result {
  width: 100%;
  max-height: 400px;
  background-color: #fff;
  padding: 8px!important;
  overflow: auto;
  margin-left: 8px;
  margin-top: -7px;
  margin-right: 8px;
}
.text-overflow-ellipses {
  white-space: nowrap!important;
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  padding-right:25px;
  cursor: pointer;
  caret-color: transparent; 
}
.cursor-pointer {
  cursor: pointer;
}
      `}</style>
    </>
  );
};

export default Employment;
